import { render, staticRenderFns } from "./Taxability.vue?vue&type=template&id=871c5460&scoped=true"
import script from "./Taxability.vue?vue&type=script&lang=ts"
export * from "./Taxability.vue?vue&type=script&lang=ts"
import style0 from "./Taxability.vue?vue&type=style&index=0&id=871c5460&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c5460",
  null
  
)

export default component.exports